import { ReactNode, useMemo } from 'react';

import { BREAKPOINT_MD } from '#/features/layout/media-queries';

import createSafeContext from '#/utils/createSafeContext';
import { WindowSize, useWindowSize } from '#/utils/useWindowSize';

type ScreenSizeView = 'sm' | 'md';

interface View {
  readonly size: ScreenSizeView;
}

interface ProviderProps {
  readonly children: ReactNode;
}

export function ScreenSizeProvider(props: ProviderProps) {
  const windowSize = useWindowSize();

  const view = useView(windowSize);

  return <ViewProvider value={view}>{props.children}</ViewProvider>;
}

export const [useScreenSize, ViewProvider] = createSafeContext<View>(
  'ScreenSizeViewProvider',
);

function useView(windowSize: WindowSize): View {
  const size = sizeView(windowSize);

  return useMemo(
    () => ({
      size,
    }),
    [size],
  );
}

function sizeView(windowSize: WindowSize): ScreenSizeView {
  if (windowSize.width == null) return 'md';
  if (windowSize.width < BREAKPOINT_MD) return 'sm';
  return 'md';
}
